export const numEmployeesOptions = [
  { name: '0-50', value: '0-50' },
  { name: '50-1000', value: '50-1000' },
  { name: '1000-5000', value: '1000-5000', isEnterprise: true },
  { name: '5000+', value: '5000+', isEnterprise: true }
]
